<template>
  <div class="btnBox">
    <div class="trans" />
    <!-- 不在APP内 也不在小程序内 -->
    <div v-if="host" class="btn-con">
      <!-- {"download_guide_display":1,"applet_guide_display":0,"applet_type":"taxi","applet_link":"12333"} -->
      <div class="total-value">
        优惠券已放入账户<span>{{ tel }}</span>
      </div>
      <div v-show="channel!=='xiaoxiang'">
        <template v-if="guideData.download_guide_display">
          <!-- 微信环境 -->
          <div v-show="isInWechat">
            <div
              v-if="isiPhone && isApp !== 'minwx' && isLastVersion && isWxReady && htmlStrBtn"
            >
              <div class="use" v-html="htmlStrBtn" />
            </div>
            <div
              v-if="!isiPhone || isApp === 'minwx' || !isLastVersion || !isWxReady"
            >
              <div class="use" @click="goApp">下载嘀嗒出行App，立即使用</div>
            </div>
          </div>
          <!-- 其他H5环境 -->
          <div v-if="!isInWechat">
            <div class="use" @click="goApp">下载嘀嗒出行App，立即使用</div>
          </div>
        </template>
        <div>
          <!-- applet_guide_display: 0, // 是否显示打开小程序
          applet_type - taxi 出租车 | 'carpool' 顺风车 | taxiqr 智慧码 | 'driver 车主'-->
          <!-- v-if="guideData.applet_guide_display && guideData.applet_type === 'carpool'" -->
          <template v-if="guideData.applet_guide_display">
            <!-- 在微信内 -->
            <div v-show="isInWechat && isLastVersion && appClient !== 'my'" class="wx-btn">
              <!-- 出租车 -->
              <div
                v-show="guideData.applet_type === 'taxi'"
                :class="{'mini-btn': !htmlStrCarpool}"
                v-html="htmlStrCarpool"
              />
              <!-- 顺风车 -->
              <div
                v-show="guideData.applet_type === 'carpool'"
                :class="{'mini-btn': !htmlStrTaxi}"
                v-html="htmlStrTaxi"
              />
              <!-- 智慧码 -->
              <div
                v-show="guideData.applet_type === 'taxiqr'"
                :class="{'mini-btn': !htmlStrTaxiqr}"
                v-html="htmlStrTaxiqr"
              />
              <!-- 去车主认证小程序 -->
              <div
                v-show="guideData.applet_type === 'driver'"
                :class="{'mini-btn': !htmlStrTaxidriver}"
                v-html="htmlStrTaxidriver"
              />
            </div>
            <div v-if="(!isInWechat && isApp !== 'app') || appClient === 'my'" class="wx-btn">
              <div
                v-show="guideData.applet_type === 'carpool'"
                class="mini-btn"
                @click="openMini('carpool')"
              >
                打开嘀嗒顺风车小程序
              </div>
              <div
                v-show="guideData.applet_type === 'taxi'"
                class="mini-btn"
                @click="openMini('taxi')"
              >
                打开嘀嗒出租车小程序
              </div>
              <div
                v-show="guideData.applet_type === 'taxiqr'"
                class="mini-btn"
                @click="openMini('taxiqr')"
              >
                打开智慧出行小程序
              </div>
              <div
                v-show="guideData.applet_type === 'driver'"
                class="mini-btn"
                @click="openMini('driver')"
              >
                立即认证车主，去使用优惠
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- 在 app 或者 小程序环境  -- 车主小程序没有查看优惠卷页面，加区分 -->
    <div v-else class="btn-con">
      <div class="total-value">共领取价值<span>{{ totalValue }}</span>元优惠券</div>
      <div v-if="guideData.applet_type !== 'driver'" class="all-coupon" @click="goCoupon">查看全部优惠券<span v-if="!is_jingdong">({{ couponList.length }})</span></div>
      <div class="use" @click="goApp"><span>{{ guideData.applet_type == 'driver' ? '立即认证车主，去使用优惠' : '立即使用' }}</span></div>
    </div>
  </div>
</template>

<script>
  import { getQueryString } from '@common/libs/util.url.js'
  import Env, { compareVersion } from '@common/libs/util.env.js'
  import { generatescheme } from '@/api/newapi.js'
  import { addStat } from '@/utils/stat.util'
  import { getAppClient } from '@/utils/environment.util'
  const channel = getQueryString('channel') || '' // DIDAWEB-1313 渠道为小象H5登录
  const notoapp = getQueryString('notoapp') || null // 是否跳转app
  const zyf = getQueryString('zyf') || null // 是否展示下载按钮
  let isLastVersion = false
  const jump = 'didapinche://home'
  const pageShow = window.location
  const CID =
    getQueryString('cid') ||
    getQueryString('user_cid') ||
    getQueryString('userCid') ||
    ''
  const PID = getQueryString('PID') || '' // WEBHF-973
  const isTaxiQr = getQueryString('toMini') === 'minipg_taxiqr_wx' || getQueryString('goodCid') === 'c1176e07038949279582b434d161f1ba'
  const app_lient = getAppClient() // 获取环境

  if (Env.inWechat) {
    const wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i)
    const wxVersion = wechatInfo[1] // 获取微信版本号
    if (wxVersion && compareVersion(wxVersion, '7.0.12') >= 0) {
      isLastVersion = true
    }
  }
  export default {
    name: 'CouponBtn',
    props: [ // guideData 接口查询的当前环境全面信息
      'couponList',
      'wechatLink',
      'wechatUrl',
      'isApp',
      'tel',
      'totalValue',
      'dataForCoupon',
      'guideData'
    ],
    data() {
      return {
        appClient: getAppClient(true),
        isiPhone: Env.isiPhone,
        isWxReady: false,
        htmlStrTaxi: '',
        htmlStrTaxiqr: '', // 智慧码小程序
        htmlStrTaxidriver: '', // 车主认证
        htmlStrCarpool: '',
        htmlStrBtn: '',
        // 系统版本要求为：iOS 10.3及以上、Android 5.0及以上
        isInWechat: Env.inWechat, // 在微信环境内而且微信版本要 微信版本要求为：7.0.12及以上
        isLastVersion,
        channel,
        applet_link: '',
        is_jingdong: getQueryString('type') && getQueryString('type') === 'jingdong'
      }
    },
    computed: {
      host() {
        return this.isApp === 'other' || this.isApp === 'wxh5'
      }
    },
    watch: {
      'dataForCoupon.isget': {
        handler() {
          this.calc()
        }
      }
    },
    updated() {
      if (this.isWxReady && (this.htmlStrTaxiqr || this.htmlStrTaxidriver || this.htmlStrTaxi || this.htmlStrCarpool || this.htmlStrBtn)) {
        const val = (this.$el.offsetHeight) * 7.5 / window.innerWidth
        this.$emit('caclPadding', val)
      }
    },
    mounted() {
      // console.log('guideData', this.guideData)
      this.initHidden()
      const _this = this
      if (this.isLastVersion) {
        // eslint-disable-next-line no-undef
        wx.ready(() => {
          _this.isWxReady = true
          // 需要等待微信ready的时候, 创建微信开放标签
          const pathTaxi = _this.guideData.applet_link || 'pages/index.html' // gh_49e3fa80623f
          // 智慧码小程序
          const pathTaxiqr = _this.guideData.applet_link || '/pages/index/index.html' // gh_49e3fa80623f
          // 车主认证小程序
          const pathTaxidriver = _this.guideData.applet_link || '/pages/index/index.html' // gh_49e3fa80623f
          const pathCarpool = _this.guideData.applet_link || 'pages/index/index.html'
          _this.htmlStrCarpool = `
	            <wx-open-launch-weapp
	                username="gh_6da657e25324"
	                path="${pathCarpool}"
                  class="mini-btn"
                  id="WXMINI"
	              >
	                <template>
	                  <div
	                  style="
                      color: #4d5663;
                      padding: 0.6rem 0;
	                    text-align:center;
                      font-weight: 800;
	                  "
	                  >打开嘀嗒出租车小程序</div>
	                </template>
	              </wx-open-launch-weapp>
	              `
          _this.htmlStrTaxi = `
	            <wx-open-launch-weapp
	                id="weappCarpool"
	                username="gh_49e3fa80623f"
	                path="${pathTaxi}"
                  class="mini-btn"
	              >
	                <template>
	                  <div
	                  style="
                      color: #4d5663;
                      padding: 0.6rem 0;
                      font-weight: 800;
	                    text-align:center;
	                  "
	                  >打开嘀嗒顺风车小程序</div>
	                </template>
	              </wx-open-launch-weapp>
	              `
          _this.htmlStrTaxiqr = `
	            <wx-open-launch-weapp
	                id="weappCarpool"
	                username="gh_9b66351cf1c4"
	                path="${pathTaxiqr}"
                  class="mini-btn"
	              >
	                <template>
	                  <div
	                  style="
                      color: #4d5663;
                      padding: 0.6rem 0;
                      font-weight: 800;
	                    text-align:center;
	                  "
	                  >打开智慧出行小程序</div>
	                </template>
	              </wx-open-launch-weapp>
	              `
          _this.htmlStrTaxidriver = `
	            <wx-open-launch-weapp
	                id="weappCarpool"
	                username="gh_4bb9c32f99dd"
	                path="${pathTaxidriver}"
                  class="mini-btn"
	              >
	                <template>
	                  <div
	                  style="
                      color: #4d5663;
                      padding: 0.6rem 0;
                      font-weight: 800;
	                    text-align:center;
	                  "
	                  >立即认证车主，去使用优惠</div>
	                </template>
	              </wx-open-launch-weapp>
	              `
          // appid="wxd3a1541d4423bf8f"
          _this.htmlStrBtn = `
	              <wx-open-launch-app
	                appid="wxd3a1541d4423bf8f"
	                id="launchapp"
	                extinfo="home"
                  class="use"
	              >
	                <template>
	                  <div
                      style="
                      font-weight: 800;
                      color: #23292f;
                      text-align:center;
                      padding: 0.6rem 0;"
                    >下载嘀嗒出行App，立即使用</div>
	                </template>
	              </wx-open-launch-app>
	            `
          _this.$nextTick(() => {
            const launchapp = document.getElementById('launchapp')
            const weappCarpool = document.getElementById('weappCarpool')
            const WXMINI = document.getElementById('WXMINI')
            if (launchapp) {
              launchapp.addEventListener('ready', () => {
              })
              launchapp.addEventListener('launch', () => {
              })
              launchapp.addEventListener('error', () => {
                _this.goApp()
              })
            }
            if (weappCarpool) {
              weappCarpool.addEventListener('ready', () => {
              })
              weappCarpool.addEventListener('launch', () => {
                addStat('领券模板打开APP  打开小程序  PID=' + PID || '', CID) // 添加埋点
              })
              weappCarpool.addEventListener('error', () => {
              })
            }
            if (WXMINI) {
              WXMINI.addEventListener('ready', () => {
              })
              WXMINI.addEventListener('launch', () => {
                addStat('领券模板打开APP  打开小程序  PID=' + PID || '', CID) // 添加埋点
              })
              WXMINI.addEventListener('error', () => {
              })
            }
            if (_this.isWxReady && (_this.htmlStrTaxiqr || _this.htmlStrTaxidriver || _this.htmlStrTaxi || _this.htmlStrCarpool || _this.htmlStrBtn)) {
              const val = (_this.$el.offsetHeight) * 7.5 / window.innerWidth
              _this.$emit('caclPadding', val)
            }
          })
        })
      }
    },
    methods: {
      calc() {
        this.$nextTick(() => {
          const val = (this.$el.offsetHeight) * 7.5 / window.innerWidth
          this.$emit('caclPadding', val)
        })
      },
      /**
       * @description: 跳转公众号
       * @param {*}
       * @return {*}
       */
      toWechat() {
        window.location =
          this.wechat_link || 'https://mp.weixin.qq.com/s/WiwYxQpe6PIUtva0Dv7lTw'
      },
      /**
       * @description: 非小程序&&非微信环境打开往出租车首页
       * @param {*}
       * @return {*}
       */
      openMini(type) {
        addStat('领券模板打开APP  打开小程序  PID=' + PID || '', CID) // 添加埋点
        if (type === 'carpool') {
          if (getAppClient(true) === 'my') {
            window.location = 'alipays://platformapi/startapp?appId=2019112669404960'
          } else {
            addStat('领券模板微信scheme跳转' || '', CID, 'minipg_carpool_wx') // 添加埋点
            this.generateschemeFn('minipg_carpool_wx')
          }
        } else if (type === 'taxi') {
          addStat('领券模板微信scheme跳转' || '', CID, 'minipg_didachuxing') // 添加埋点
          this.generateschemeFn('minipg_didachuxing')
        } else if (type === 'taxiqr') {
          addStat('领券模板微信scheme跳转' || '', CID, 'minipg_taxiqr') // 添加埋点
          this.generateschemeFn('minipg_taxiqr')
        } else if (type === 'driver') {
          addStat('领券模板微信scheme跳转' || '', CID, 'minipg_taxidriver') // 添加埋点
          if (getAppClient(true) === 'my') {
            window.location = 'alipays://platformapi/startapp?appId=2021003130648091&page=pages/index/index'
          } else {
            this.generateschemeFn('minipg_driver_certify_wx')
          }
        }
      },
      generateschemeFn(name) {
        const obj = {
          app_name: name,
          path: '',
          query: '',
          is_expire: false,
          env_version: 'release',
          user_cid: CID
        }
        generatescheme(obj).then(res => {
          if (res.data.code === 0) {
            window.location = res.data.openlink
          } else {
            this.$didafe.toast('打开错误，请稍后重试')
          }
        })
      },
      // 查看我的优惠券
      goCoupon() {
        if (this.isApp === 'app') {
          if (this.is_jingdong) {
            window.location =
              'https://m.jr.jd.com/mjractivity/rn/coupon-rn/index.html?showhead=no&RN=coupon-rn&tab=THIRD_PARTNER&from=singlemessage&isappinstalled=0'
          } else {
            // window.location = 'didapinche://coupon';
            window.location = 'didapinche://walletInfo?&role=1'
          }
        } else {
          // 是否跳转到智慧码
          // eslint-disable-next-line no-undef
          app_lient.navigateTo({ url: isTaxiQr ? '/pagesMy/myCoupon/myCoupon' : '/pagesMy/couponList/couponList' }) // pages/couponlist
        }
      },
      /**
       * @description: // 立即使用
       * @param {*}
       * @return {*}
       */
      goApp() {
        addStat('领券模板打开APP PID=' + PID || '', CID) // 添加埋点
        if (this.isApp === 'app') { // app内
          window.location = 'didapinche://home'
        } else if (this.isApp === 'minwx') { // 小程序
          // 小程序内展示H5,后跳转回小程序
          const parmas = { url: '' }
          if (['driver', 'taxiqr'].includes(this.guideData.applet_type)) {
            parmas.url = '/pages/index/index'
          } else {
            parmas.url = '/pages/index'
          }
          // eslint-disable-next-line no-undef
          app_lient.reLaunch(parmas)
          // app_lient.reLaunch({ url: isTaxiQr ? '/pages/index/index' : '/pages/index' })
        } else if (this.isApp === 'other') { // 其他环境：微信内H5和浏览器H5
          if (notoapp) {
            this.$didafe.toast(
              '微信搜索“嘀嗒出行顺风车拼车”小程序，或者应用商店搜索“嘀嗒出行”下载APP',
              { wordWrap: true }
            )
          } else if (zyf) {
            this.$didafe.toast(
              '在出租车智慧出行或嘀嗒出行app中网约出租车即可使用',
              { wordWrap: true }
            )
          } else {
            // window.location = 'https://www.didapinche.com/adh5/static/toapp/toapp.html';
            this.downloadApp()
          }
        }
      },
      handleToast() {
        if (this.is_jingdong) {
          this.$didafe.toast('可在京东金融App中查看', { wordWrap: true })
        } else {
          this.$didafe.toast('可在嘀嗒出行App「钱包-优惠券」中查看', {
            wordWrap: true
          })
        }
      },
      /**
       * @description: 尝试去APP首页 不行则自动打开下载链接
       * @param {*}
       * @return {*}
       */
      downloadApp() {
        if (Env.inWechat) {
          this.startDownload()
        } else {
          window.location = 'didapinche://home'
          this.appDownload = setTimeout(() => {
            this.startDownload()
          }, 2000)
        }
      },
      /**
       * @description: 打开下载链接
       * @param {*}
       * @return {*}
       */
      startDownload() {
        // 移动端打开商店
        if (Env.isiPhone || Env.isAndroid) {
          if (Env.inWechat) {
            // 打开应用宝
            window.location =
              '//a.app.qq.com/o/simple.jsp?pkgname=com.didapinche.booking&android_schema=' +
              encodeURIComponent(jump) +
              '&ios_scheme=' +
              encodeURIComponent(jump)
          } else {
            if (Env.isiPhone && this.guideData.ios_download_link) { // 如果有ios渠道包就直接下载渠道包
              const a = document.createElement('a')
              a.href = this.guideData.ios_download_link
              // a.href = 'http://www.didapinche.com/getapk.php?c=ch241&t.apk';
              a.click()
              addStat('领券模板安装包下载  PID=' + PID || '', CID) // 添加埋点
            } else if (Env.isAndroid && this.guideData.download_link) {
              const a = document.createElement('a')
              a.href = this.guideData.download_link
              // a.href = 'http://www.didapinche.com/getapk.php?c=ch241&t.apk';
              a.click()
              addStat('领券模板安装包下载  PID=' + PID || '', CID) // 添加埋点
            } else {
              // 在H5内  ios可以直接打开苹果商店(安卓直接下载apk包)  在微信内不能打开这个地址(ios, 安卓都不行)
              window.location = '//www.didapinche.com/getapk.php'
            }
          }
        } else {
          // 打开官网
          window.location = '//www.didapinche.com/'
        }
      },
      /**
       * @description:
       * @param {*}
       * @return {*}
       */
      initHidden() {
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'hidden') {
            if (this.appDownload) {
              this.appDownload = null
              clearTimeout(this.appDownload)
            }
          } else {
            window.location = pageShow
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
	.btnBox {
		.trans {
			height: 0.72rem;
			background: linear-gradient(
				180deg,
				rgba(255, 255, 255, 0) 6%,
				rgba(255, 255, 255, 0.43) 28%,
				#ffffff 67%
			);
		}
	}
  .oh {
    overflow: hidden;
  }

	.btn-con {
		background: #ffffff;
    overflow: hidden;
    padding-bottom: 0.32rem;

		.wx-btn {
			margin: 0 auto;
			overflow: hidden;
		}

		.total-value {
      margin-bottom: 0.24rem;
			font-size: 0.26rem;
      color: #4e556c;
			text-align: center;

			span {
				color: #a87c15;
				font-weight: 700;
			}
		}

		.all-coupon {
			width: 6.1rem;
			height: 1rem;
			line-height: 1rem;
			text-align: center;
			font-family: PingFangSC, PingFangSC-Medium;
			margin: 0 auto;
			margin-bottom: 0.4rem;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #FFF;
      border: 0.02rem solid #4d5663;
      border-radius: 0.42rem;
      font-size: 0.34rem;
      font-weight: 700;
      color: #4d5663;
      letter-spacing: -0.01rem;
		}
	}

	.official {
		margin-top: 0.42rem;
		position: relative;
		width: 100%;
		height: 1.72rem;
		background: url("https://static.didapinche.com/pics/g/93po7lc4f3mgongzhonghao.png")
			no-repeat left top/100%;
		.officialTxt {
			font-size: 0.22rem;
			font-family: PingFangSC, PingFangSC-Regular;
			font-weight: 400;
			color: #4d5663;
			position: absolute;
			top: 0.96rem;
			left: 0.4rem;
		}
		.officialBtn {
			width: 1.6rem;
			height: 0.6rem;
			background: #ffbc00;
			border-radius: 0.08rem;
			position: absolute;
			top: 0.54rem;
			right: 0.4rem;
			font-size: 0.24rem;
			font-family: PingFangSC, PingFangSC-Medium;
			font-weight: 700;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #23292f;
		}
	}
</style>

<style  lang="scss">
	.use {
    width: 6.1rem;
    height: 1rem;
    background: #ffdb75;
    border-radius: 0.4rem;
    text-align: center;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    outline: none;
    border: 0 none;
    font-size: 0.34rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 700;
    color: #23292f;
    letter-spacing: -0.01rem;
	}
  .mini-btn-wrap {
    overflow: hidden;
  }
  .mini-btn {
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-top: 0.4rem;
    text-align: center;
    line-height: 1rem;
    background: #FFF;
    outline: none;
    width: 6.1rem;
    height: 1rem;
    border: 0.02rem solid #4d5663;
    border-radius: 0.42rem;
    font-size: 0.34rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 700;
    color: #4d5663;
    letter-spacing: -0.01rem;
  }
</style>
